// @flow

import { ChatFeedback, type ChatchampButton, type ChatBubbleMessage } from '@chatchamp/chatchamp-types'

import { logger } from '../../common'
import { createClick } from '../../common/api/chatchampApi'
import { CHATBOT_EVENTS, dispatchChatchampEvent } from '../../main/eventTracking'
import { sendExitButton, sendFeedbackButton, sendPayloadButton } from '../utils/api'
import { ButtonTypes } from '../components/ChatchampButton/ButtonTypes'

function buildUrl (url: string, productId: ?string = null): string {
  if (!productId) return url

  const urlObject = new URL(url)
  urlObject.searchParams.set('productId', productId)
  return urlObject.toString()
}

export default {
  methods: {
    async clickButton (button: ChatchampButton, message: ?ChatBubbleMessage<any> = null, productId: ?string = null) {
      logger.info(`Clicked on button ${button.title}.`)
      if (button.growthToolId) {
        await this.$store.dispatch('welcomeMessageShownById', button.growthToolId)
        this.$store.commit('setLastMessageReceived', null)
      }
      if (button.productId) {
        this.$emit('product-clicked', { productId: button.productId, ...(message && { chatbotId: message.content.chatbotId }) })
      }
      if (button.attribute) dispatchChatchampEvent(CHATBOT_EVENTS.AttributeSet, button.attribute)
      if (button.type === ButtonTypes.POSTBACK && message) {
        await this.$store.dispatch('addTextMessageToList', button.title)
        await sendPayloadButton(button.payload, button.title, message.id)
      } else if (button.url) {
        const url = buildUrl(button.url || '', productId)
        window.open(url)
        const { customerId, subscriberId } = this.$store.state
        await createClick(customerId, subscriberId, button.payload, {
          productId: productId
        })
      } else if (button.type === ButtonTypes.OPEN_CHAT) {
        dispatchChatchampEvent(CHATBOT_EVENTS.OpenChatClick, {
          customerId: this.$store.state.customerId,
          subscriberId: this.$store.state.subscriberId,
          welcomeMessageId: this.$store.state.welcomeMessage?.welcomeMessage.id,
          device: this.$store.state.device
        })
        await this.$store.dispatch('openChatClicked')
      } else if (button.type === ButtonTypes.MAYBE_LATER) {
        logger.info('Maybe later button clicked.')
        await this.$store.dispatch('setMessageHistory', [])
        await this.$store.dispatch('welcomeMessageClosed')
      } else if (button.type === ButtonTypes.EXIT) {
        logger.info('Exit button clicked.')
        await this.$store.dispatch('addTextMessageToList', button.title)
        await sendExitButton(button.title, message?.content.messageId)
      } else if (button.type === ButtonTypes.POSITIVE_FEEDBACK) {
        logger.info('Positive feedback button clicked.')
        await this.$store.dispatch('addTextMessageToList', button.title)
        await sendFeedbackButton(button.title, message?.content.messageId, ChatFeedback.POSITIVE)
      } else if (button.type === ButtonTypes.NEGATIVE_FEEDBACK) {
        logger.info('Negative feedback button clicked.')
        await this.$store.dispatch('addTextMessageToList', button.title)
        await sendFeedbackButton(button.title, message?.content.messageId, ChatFeedback.NEGATIVE)
      }
    }
  }
}
